import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Counter from "./Counter";

const Stat = ({
  icon,
  val,
  text,
}: {
  icon: IconDefinition;
  val: number;
  text: string;
}) => {
  return (
    <div className="flex bordered stat">
      <FontAwesomeIcon icon={icon} />
      <div className="grid">
        <label className="subt">{text}</label>
        <Counter targetValue={val.toString()} />
      </div>
    </div>
  );
};

export default Stat;
